import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { AdvanceSearchService } from '../../../services/Advance-search/advance-search.service';
import { ToastService } from '../../../services/toast/toast.service';

@Component({
  selector: 'app-manual-edit-adhaar',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './manual-edit-adhaar.component.html',
  styleUrl: './manual-edit-adhaar.component.scss'
})
export class ManualEditAdhaarComponent {

  aadhaar: string = '';

  errorMessage: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ManualEditAdhaarComponent>,
    private advanceSearch: AdvanceSearchService,
    private toaster: ToastService,
  ) {

    this.aadhaar =
      data?.devoteeDetails?.aadhaarNumber ||
      data?.aadhaarNumber ||
      '';

  }

  close(): void {

    this.dialogRef.close();

  }

  continue(): void {

    const payLoad = {

      familyCode:
        this.data.devoteeDetails.devoteeFamilyCode,

      devoteeId:
        this.data.devoteeDetails.devoteeId,

      aadhaarNumber:
        this.aadhaar

    };

    this.advanceSearch.UpdateManualAdhaar(payLoad).subscribe({

      next: (res: any) => {

        this.toaster.success(
          'Aadhaar successfully updated'
        );

        this.dialogRef.close(true);

      },

      error: (err: any) => {

        this.errorMessage =
          err?.error?.message || 'Something went wrong';

        this.toaster.error(this.errorMessage);

      }

    });

  }

}